export const availabletimes = {"Monday":["19:00-20:00"],"Tuesday":["notavailable"],"Wednesday":["19:00-20:00"],"Thursday":["16:30-17:30","19:00-20:00"],"Friday":["notavailable"],"Saturday":["11:00-12:00","11:30-12:30","12:00-13:00","13:30-14:30","14:30-15:30","16:00-17:00"],"Sunday":["11:00-12:00","11:30-12:30","12:00-13:00","13:30-14:30","14:30-15:30","16:00-17:00"]}



